import React, { useMemo, useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useApi } from "../../hooks/useApi";
import { toast } from "react-toastify";
import DmeStatusUpdateModal from "./DmeStatusUpdateModal";

const norm = (s) =>
    (s ?? "")
        .toString()
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .toLowerCase();

const DmeFolioStatusTable = ({
    items = [],
    loading,
    onDetail,
    page = 1,
    setPage = () => { },
    pageSize = 25,
    setPageSize = () => { },
    q = "",
    setQ = () => { },
    onStatusUpdated,
    chain = "",
    from = null,
    to = null,
}) => {
    const { get } = useApi();
    const [statusModalOpen, setStatusModalOpen] = useState(false);
    const [selectedFolio, setSelectedFolio] = useState(null);
    const [exporting, setExporting] = useState(false);

    /*const exportToExcel = () => {
        try {
            setExporting(true);
            const source = filtered; // Exporta todos los filtrados

            const data = source.map((r) => ({
                ReturnId: r.returnId,
                Folio: r.reference,
                Sucursal: r.branch,
                Cadena: r.chain,
                UltimaActualizacion: r.lastUpdate ? new Date(r.lastUpdate).toLocaleString("es-ES") : "", // Uso explícito de es-ES
                Estatus: statusLabels[r.status] || "Desconocido",
            }));

            const ws = XLSX.utils.json_to_sheet(data);
            //ws["E1"].v = "Última actualización"; 

            // Especifica la opción de codificación aquí
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "DME_Folios");

            // Escribe el archivo con encoding correcto
            const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

            // Función para convertir a formato binario
            const s2ab = (s) => {
                const buf = new ArrayBuffer(s.length);
                const view = new Uint8Array(buf);
                for (let i = 0; i < s.length; i++) {
                    view[i] = s.charCodeAt(i) & 0xff; // Convierte a UTF-8
                }
                return buf;
            };

            // Convierte a Blob y guarda usando FileSaver
            const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
            const pad = (n) => String(n).padStart(2, "0");
            const now = new Date();
            const name = `dme_folios_${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}.xlsx`;
            saveAs(blob, name);
        } catch (err) {
            console.error("Export to Excel failed:", err);
        } finally {
            setExporting(false);
        }
    };*/

    const exportToExcel = async () => {
        try {
            setExporting(true);

            // Llamar a ExportFolios que ya trae todo
            const response = await get("ExportFolios", {
                params: { chain, from, to },
            });

            console.log(response);

            const exportData = [];

            // response.folios ya contiene todos los folios con sus detalles
            response.folios?.forEach((folio) => {
                if (folio.details && folio.details.length > 0) {
                    // Una fila por cada detalle
                    folio.details.forEach((detail) => {
                        exportData.push({
                            ReturnId: folio.returnId,
                            Folio: folio.reference,
                            Sucursal: folio.branch,
                            Cadena: folio.chain,
                            Estatus: statusLabels[folio.status] || "Desconocido",
                            UltimaActualizacion: folio.lastUpdate
                                ? new Date(folio.lastUpdate).toLocaleString("es-ES")
                                : "",
                            "Cliente QA": detail.clientQA || "-",
                            "Nombre": detail.clientName || "-",
                            Sku: detail.sku || "-",
                            SkuQA: detail.skuQA || "-",
                            Descripcion: detail.skuDescription || "-",
                            MU: detail.mu || "-",
                            Cantidad: detail.quantityReturn || "-",
                            Precio: detail.price || "-",
                            Total: detail.total || "-",
                        });
                    });
                } else {
                    // Si no hay detalles, mostrar una fila del folio
                    exportData.push({
                        ReturnId: folio.returnId,
                        Folio: folio.reference,
                        Sucursal: folio.branch,
                        Cadena: folio.chain,
                        Estatus: statusLabels[folio.status] || "Desconocido",
                        UltimaActualizacion: folio.lastUpdate
                            ? new Date(folio.lastUpdate).toLocaleString("es-ES")
                            : "",
                        ClientQA: "-",
                        Sku: "-",
                        SkuQA: "-",
                        MU: "-",
                        Cantidad: "-",
                        Precio: "-",
                        Total: "-",
                        NombreCliente: "-",
                        DescripcionSku: "-",
                    });
                }
            });

            // Crear workbook
            const ws = XLSX.utils.json_to_sheet(exportData);
            ws["!cols"] = [
                { wch: 12 }, // ReturnId
                { wch: 15 }, // Folio
                { wch: 15 }, // Sucursal
                { wch: 12 }, // Cadena
                { wch: 18 }, // Estatus
                { wch: 25 }, // UltimaActualizacion
                { wch: 12 }, // ClientQA
                { wch: 12 }, // Sku
                { wch: 12 }, // SkuQA
                { wch: 10 }, // MU
                { wch: 12 }, // Cantidad
                { wch: 12 }, // Precio
                { wch: 12 }, // Total
                { wch: 20 }, // NombreCliente
                { wch: 25 }, // DescripcionSku
            ];

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Folios");

            // Generar archivo
            const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
            const s2ab = (s) => {
                const buf = new ArrayBuffer(s.length);
                const view = new Uint8Array(buf);
                for (let i = 0; i < s.length; i++) {
                    view[i] = s.charCodeAt(i) & 0xff;
                }
                return buf;
            };

            const pad = (n) => String(n).padStart(2, "0");
            const now = new Date();
            const fileName = `dme_folios_${now.getFullYear()}-${pad(
                now.getMonth() + 1
            )}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(
                now.getMinutes()
            )}-${pad(now.getSeconds())}.xlsx`;

            const blob = new Blob([s2ab(wbout)], {
                type: "application/octet-stream",
            });
            saveAs(blob, fileName);
            //toast.success("Exportación completada");
        } catch (err) {
            console.error("Export to Excel failed:", err);
            //toast.error("Error al exportar a Excel");
        } finally {
            setExporting(false);
        }
    };

    // búsqueda local (sobre todos los items)
    const statusLabels = {
        0: "Por Clasificar",
        1: "Error",
        2: "Pendiente",
        3: "Retenido",
        4: "Cancelado",
        5: "Duplicado",
        6: "En Aclaración",
        10: "Clasificado",
    };

    const filtered = useMemo(() => {
        const nq = norm(q);
        if (!nq) return items;
        return items.filter((row) =>
            [
                row.returnId,
                row.reference,
                row.branch,
                row.chain,
                row.lastUpdate ? new Date(row.lastUpdate).toLocaleString().replace(",", "") : "",
                String(row.status ?? ""),
                statusLabels[row.status] || "",
            ]
                .map(norm)
                .some((v) => v.includes(nq))
        );
    }, [items, q]);

    // paginación local
    const total = filtered.length;
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    const startIdx = (page - 1) * pageSize;
    const endIdx = Math.min(startIdx + pageSize, total);
    const pageRows = filtered.slice(startIdx, endIdx);

    const goPrev = () => setPage((p) => Math.max(1, p - 1));
    const goNext = () => setPage((p) => Math.min(totalPages, p + 1));

    const statusColors = {
        0: "bg-green-100 text-green-700",
        1: "bg-gray-100 text-gray-700",
        2: "bg-gray-100 text-gray-700",
        3: "bg-purple-100 text-purple-700",
        4: "bg-red-100 text-red-700",
        5: "bg-pink-100 text-pink-700",
        6: "bg-orange-100 text-orange-700",
        10: "bg-blue-100 text-blue-700",
    };

    const handleOpenStatusModal = (item) => {
        setSelectedFolio({
            returnId: item.returnId,
            reference: item.reference,
            branch: item.branch,
            status: item.status,
        });
        setStatusModalOpen(true);
    };

    const handleStatusUpdated = () => {
        setStatusModalOpen(false);
        setSelectedFolio(null);
        onStatusUpdated?.();
    };

    if (loading) {
        return <div className="text-center py-10 text-gray-500">Cargando registros...</div>;
    }

    if (!items.length) {
        return <div className="text-center py-10 text-gray-500">No se encontraron registros</div>;
    }

    return (
        <div className="bg-white rounded-xl shadow p-4">
            <div className="flex flex-wrap gap-4 mb-4">
                <div className="ml-auto">
                    <input
                        type="text"
                        value={q}
                        onChange={(e) => {
                            setQ(e.target.value);
                            setPage(1);
                        }}
                        placeholder="Buscar (estatus, folio, sucursal, cadena)"
                        className="border rounded px-3 py-2 text-sm w-72"
                    />
                </div>
                <button
                    onClick={exportToExcel}
                    disabled={exporting}
                    className="bg-green-800 text-white px-3 py-2 rounded text-sm hover:bg-green-900 disabled:opacity-60"
                >
                    {exporting ? "Exportando..." : "Exportar a Excel"}
                </button>
            </div>

            <div className="overflow-x-auto">
                <table className="min-w-full text-sm text-left">
                    <thead>
                        <tr className="border-b bg-gray-50 text-gray-600">
                            <th className="py-2 px-3">ReturnId</th>
                            <th className="py-2 px-3">Folio</th>
                            <th className="py-2 px-3">Sucursal</th>
                            <th className="py-2 px-3">Cadena</th>
                            <th className="py-2 px-3">&Uacute;ltima actualizaci&oacute;n</th>
                            <th className="py-2 px-3">Estatus</th>
                            <th className="py-2 px-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {pageRows.map((row) => (
                            <tr
                                key={`${row.returnId}-${row.reference}-${row.branch}`}
                                className="border-b hover:bg-gray-50"
                            >
                                <td className="py-2 px-3">{row.returnId}</td>
                                <td className="py-2 px-3 font-semibold">{row.reference}</td>
                                <td className="py-2 px-3">{row.branch}</td>
                                <td className="py-2 px-3">{row.chain}</td>
                                <td className="py-2 px-3 text-xs">
                                    {row.lastUpdate ? new Date(row.lastUpdate).toLocaleString().replace(",", "") : "-"}
                                </td>
                                <td className="py-2 px-3">
                                    <span
                                        className={`px-2 py-1 rounded text-xs whitespace-nowrap ${statusColors[row.status] || "bg-gray-100 text-gray-700"
                                            }`}
                                    >
                                        {statusLabels[row.status] || "Desconocido"}
                                    </span>
                                </td>
                                <td className="py-2 px-3 text-right h-12 flex items-center justify-end gap-2">
                                    <button
                                        onClick={() => handleOpenStatusModal(row)}
                                        className="bg-yellow-500 text-white px-3 py-0.5 rounded text-xs hover:bg-yellow-600"
                                    >
                                        Cambiar
                                    </button>
                                    <button
                                        onClick={() => onDetail(row.returnId, row.reference, row.branch)}
                                        className="bg-blue-600 text-white px-3 py-0.5 rounded text-xs hover:bg-blue-700"
                                    >
                                        Detalle
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {pageRows.length === 0 && (
                            <tr>
                                <td colSpan="7" className="py-6 text-center text-gray-500">
                                    Sin coincidencias en esta página.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* footer de paginación (idéntico a DmeLogTable) */}
            {totalPages > 1 && (
                <div className="flex flex-wrap justify-between items-center gap-3 mt-4 border-t pt-3">
                    <div className="text-sm text-gray-600">
                        Mostrando{" "}
                        <span className="font-medium">{total ? startIdx + 1 : 0}</span> -{" "}
                        <span className="font-medium">{endIdx}</span> de{" "}
                        <span className="font-medium">{total}</span> registros
                    </div>

                    <div className="flex items-center gap-2 ml-auto">
                        <label className="text-sm text-gray-600">Filas</label>
                        <select
                            value={pageSize}
                            onChange={(e) => {
                                setPageSize(Number(e.target.value));
                                setPage(1);
                            }}
                            className="border rounded px-2 py-1 text-sm"
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>

                        <button
                            disabled={page <= 1}
                            onClick={goPrev}
                            className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 text-sm disabled:opacity-50"
                        >
                            -
                        </button>

                        <div className="flex items-center gap-2">
                            <span className="text-sm text-gray-600">Página</span>
                            <select
                                value={page}
                                onChange={(e) => setPage(Number(e.target.value))}
                                className="border rounded px-2 py-1 text-sm"
                            >
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                                    <option key={p} value={p}>
                                        {p}
                                    </option>
                                ))}
                            </select>
                            <span className="text-sm text-gray-600">de {totalPages}</span>
                        </div>

                        <button
                            disabled={page >= totalPages}
                            onClick={goNext}
                            className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 text-sm disabled:opacity-50"
                        >
                            +
                        </button>
                    </div>
                </div>
            )}

            {/* Modal */}
            <DmeStatusUpdateModal
                isOpen={statusModalOpen}
                onClose={() => setStatusModalOpen(false)}
                folioData={selectedFolio}
                onSuccess={handleStatusUpdated}
            />
        </div>
    );
};

export default DmeFolioStatusTable;